import * as React from 'react';

import * as ct from '../../global/controls';

interface ReservationMaxParticipantsPanelProps {
    maxParticipants: ct.FormValue<number>;
    maxParticipantsChanged: (val: number) => void;
}

const ReservationMaxParticipantsPanel = (props: ReservationMaxParticipantsPanelProps) => {
    const { maxParticipants, maxParticipantsChanged } = props;

    return <div className='row mt-15'>
        <div className='col-md-12'>
            <ct.NumberBox id='maxParticipants' labelKey={'ReservationMaxParticipantsPanel:maxParticipants'} placeholderKey={''} value={maxParticipants} callback={maxParticipantsChanged}/>
        </div>
    </div>
};

export default ReservationMaxParticipantsPanel;
